export const BREAKPOINT_MOBILE = 880
export const BREAKPOINT_MENU = 1000
export const BREAKPOINT_LARGE = 1240
